import React, { Dispatch, SetStateAction, useState } from 'react';
import AssociatedPeopleTile from './AssociatedPeopleTile';
import { PERSON_GROUP_BY } from '../../person/utils/personConstants';
import AddKeyPeopleModal from '../AddKeyPeopleModal';
import { Contact, Reference } from 'sr-types/lib/production/v1/graphql';
import { ProductionTypeSuperset } from '../helpers/productionApi';

type AssociatedKeyPeopleProps = {
    keyPeople: Array<Contact>;
    workspaceReference: Reference;
    associatedPeople: Array<Contact>;
    workspaceName?: string;
    setViewState?: Dispatch<SetStateAction<ProductionTypeSuperset>>;
    isReadOnly?: boolean;
    isSaving?: boolean;
};

export const AssociatedKeyPeople = ({
    keyPeople,
    workspaceReference,
    associatedPeople,
    workspaceName,
    setViewState,
    isReadOnly,
    isSaving
}: AssociatedKeyPeopleProps) => {
    const [isKeyPeopleModalOpen, setIsKeyPeopleModalOpen] = useState<boolean>(false);

    return (
        <>
            <AssociatedPeopleTile
                contacts={keyPeople}
                onAdd={() => setIsKeyPeopleModalOpen(true)}
                isReadOnly={isReadOnly}
                isSaving={isSaving}
                groupPeopleBy={PERSON_GROUP_BY.name}
            />
            {isKeyPeopleModalOpen && (
                <AddKeyPeopleModal
                    open
                    onClose={() => setIsKeyPeopleModalOpen(false)}
                    productionId={workspaceReference?.id}
                    peopleData={associatedPeople}
                    keyPeople={keyPeople}
                    productionRef={{ ...workspaceReference, label: workspaceName || '' }}
                    setViewState={setViewState}
                />
            )}
        </>
    );
};
